(function () {

    "use strict";

    function aplicacionesService(basicEntityService, entityService, $translate) {

        var self = this;
        self.entityService = entityService.resource("aplicaciones");

        var labels = {
            propertyName: "aplicacion",
            updateOk: $translate.instant("APLICACION.OKMODIFICACION"),
            updateError: $translate.instant("APLICACION.ERRORMODIFICACION"),
            createOk: $translate.instant("APLICACION.CONFIRMARELIMINACIONTITULO"),
            createError: $translate.instant("APLICACION.CONFIRMARELIMINACIONTITULO"),
            confirmDeleteContent: $translate.instant("APLICACION.CONFIRMARELIMINACIONCONTENIDO"),
            confirmDeleteTitle: $translate.instant("APLICACION.CONFIRMARELIMINACIONTITULO"),
            confirmDeleteOK: $translate.instant("APLICACION.CONFIRMARELIMINACIONOK"),
            confirmDeleteCancel: $translate.instant("APLICACION.CONFIRMARELIMINACIONCANCELAR"),
            deletedOk: $translate.instant("APLICACION.OKDELETE"),
            deletedCancel: $translate.instant("APLICACION.ERRORDELETE")
        };

        basicEntityService.instantiate(self, labels);
    }

    aplicacionesService.$inject = ["sphforms.basicEntityService", "solpheo.entityService", "$translate"];

    angular.module("sphforms.formacion").service("sphforms.aplicacionesService", aplicacionesService);

})();
